export default {"src":"/_next/static/media/package-expired.aca80173.svg","height":260,"width":260,"blurWidth":0,"blurHeight":0};